import styled from 'styled-components';

export const Container = styled.span`
  display: inline-block;
`;

export const LoadingContainer = styled.div`
  height: 350px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
